import { createApp } from 'vue'
import TemperatureConverter from './TemperatureConverter.vue'
import './assets/global.css'

createApp(TemperatureConverter).mount('#temperature')
